import FJImageEnhancerCardContainer from '../FJImageEnhancerCard/FJImageEnhancerCardContainer';
import FJImageManipulationInputContainer from '../FJImageManipulationInput/FJImageManipulationInputContainer';
import FJSwitchCard from '../FJSwitchCard/FJSwitchCard';
import styles from './FJImageManipulationLeft.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJUtil from '../../../util/FJUtil';
import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import classNames from 'classnames';
import FJScratchOrFoldCardContainer from '../FJScratchOrFoldCard/FJScratchOrFoldCardContainer';
import FJConstant from '../../../constants/FJConstant';

const FJImageManipulationLeft = props => {
    const {
        switchOldPhotoRestoration,
        switchPhotoColorize,
        onSwitchOldPhotoRestoration,
        onSwitchPhotoColorize,
        onGenerate,
        taskStatus,
        freeNumCreation,
        creditNumber,
        isProjectLoading,
        imageEnhancerData = {},
        switchScratchOrFold,
        photoColorizeNum,
    } = props;
    const useCredit =
        (switchOldPhotoRestoration + switchPhotoColorize + imageEnhancerData.switch + switchScratchOrFold) * 2;
    const isFree = freeNumCreation > 0 && creditNumber < useCredit;
    const isDisabled = FJUtil.isGeneratingStatus(taskStatus) || taskStatus === FJConstant.ERROR;
    const style = { width: '435px' };
    return (
        <FJAppLeft>
            <FJImageManipulationInputContainer />
            <div className={classNames(styles.title, styles.margin_top_30)}>{FJLocalStore._('image-settings')}</div>
            <FJVerticalScroller className={styles.scroll}>
                <FJSwitchCard
                    text={FJLocalStore._('ai-photo-colorizer')}
                    active={switchPhotoColorize}
                    onChange={onSwitchPhotoColorize}
                    disabled={isDisabled || photoColorizeNum !== 0}
                    style={style}
                />
                <FJSwitchCard
                    text={FJLocalStore._('ai-old-photo-restoration')}
                    active={switchOldPhotoRestoration}
                    onChange={onSwitchOldPhotoRestoration}
                    disabled={isDisabled}
                    style={style}
                />

                <FJScratchOrFoldCardContainer disabled={isDisabled} />

                <FJImageEnhancerCardContainer disabled={isDisabled} style={style} />
            </FJVerticalScroller>
            <div className={styles.footer}>
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                    disabled={isDisabled}
                />
            </div>
        </FJAppLeft>
    );
};
FJImageManipulationLeft.propTypes = {
    switchOldPhotoRestoration: PropTypes.bool,
    switchPhotoColorize: PropTypes.bool,
    onSwitchOldPhotoRestoration: PropTypes.func,
    onSwitchPhotoColorize: PropTypes.func,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    imageEnhancerData: PropTypes.object,
    isProjectLoading: PropTypes.bool,
    switchScratchOrFold: PropTypes.bool,
    photoColorizeNum: PropTypes.number,
};
export default FJImageManipulationLeft;
